import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateJournalEntryInput, UpdateJournalEntryInput } from 'shared';

import {
  createJournalEntry,
  createJournalReminder,
  updateJournalEntry,
} from '../../lib/api/endpoints';
import { notify } from '../notifications/toasts';

import { journalKeys } from './queries';

export function useCreateJournalEntry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateJournalEntryInput) => createJournalEntry(input),
    onSuccess: async (entry) => {
      if (entry.entryType === 'POST_TRADE') {
        notify({
          kind: 'POST_TRADE_REVIEW_SUBMITTED',
          symbol: entry.symbol,
          variant: 'success',
          title: `Post-trade review submitted${entry.symbol ? ` - ${entry.symbol}` : ''}`,
        });
      }
      await queryClient.invalidateQueries({ queryKey: journalKeys.all });
    },
  });
}

export function useUpdateJournalEntry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; data: UpdateJournalEntryInput }) => updateJournalEntry(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: journalKeys.all });
    },
  });
}

export function useCreateJournalReminder() {
  return useMutation({
    mutationFn: (symbol: string) => createJournalReminder(symbol),
  });
}
